module.exports = "<div class=\"filter-overview-item\" v-if=\"show\">\n\t<slot></slot>\n</div>\n"